import { PixKey } from './key.model';
import { ETipoAgenteSaquetroco, ETipoOperacao } from './qr-code-return.model';

export class PixPaymentFavored {
	codigoFimAFim: string;
	sequencial: string;
	chave: PixKey;
	conta: PixPaymentFavoredAccount;
	descricao: string;
	favorito: boolean;

	tipo: string;
	valor: number;
	codigoTransacao: string;
	chavePix: PixKey;
	informacaoAdicional: string;
	qrCodeEstatico: QrCodeEstatico;
}

export class QrCodeEstatico {
	cidade: string;
	ispbServico: string;
	nome: string;
	tipoAgente: ETipoAgenteSaquetroco;
	tipoOperacao: ETipoOperacao;
}

export class PixPaymentFavoredAccount {
	numeroConta: string;
	tipoConta: string;
	numeroAgencia: number;
	documento: string;
	iSPBCodigo: string;
	iSPBNome: string;
	nome: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/payment-favored.model.ts